import { useCallback, useState, useEffect } from 'react';
import { CancellationReassonsService } from '../../services/cancellationReasonsService';

const useSelectCancellationReasson = () => {
  const [cancellationReassons, setCancellationReassons] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getData = useCallback(async (search) => {
    setIsLoading(true);
    try {
      const data = await CancellationReassonsService.getCancellationReassons({ search });
      setCancellationReassons(data.cancellationReassons);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  return { getData, cancellationReassons, isLoading };
};

export default useSelectCancellationReasson;
